"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBusFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2 7a2 2 0 012-2h13.764a2 2 0 011.789 1.106l2.236 4.472a2 2 0 01.211.894V15a2 2 0 01-2 2s0-3-3-3-3 3-3 3h-4s0-3-3-3-3 3-3 3a2 2 0 01-2-2V7zm2 0h4v4H4V7zm6 0h4v4h-4V7zm8 0h-2v4h4l-2-4z' }),
    react_1.default.createElement("path", { d: 'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z' }))); };
exports.default = SvgBusFilled;
//# sourceMappingURL=BusFilled.js.map